/* eslint-disable jsx-a11y/anchor-is-valid */
import { useContext } from "react";
import AlertTost from "./AlertToast";
import { AuthContext } from "#contexts/authContext.jsx";
import ImagesUrl from "#constants/images.js";
import { useSideBarContext } from "#contexts/sidebarContext.jsx";
import CustomAlert from "./CustomAlert";

const Sidebar = ({ children }) => {
  const { logout } = useContext(AuthContext);
  const { topBar, toggleSidebar } = useSideBarContext();

  const handleLogout = () => {
    CustomAlert({
      title: " Are you sure you  want to  logout?",
      confirmButtonText: "Confirm",
      icon: "question",
      onConfirm: async () => {
        logout();
        AlertTost("Logout Successfully", "success");
      },
    });
  };

  return (
    <div className={`side-navbar ${topBar ? "side-hide" : ""}`}>
      <button className="closeBtn" onClick={toggleSidebar}>
        <i className="fa-solid fa-times" />
      </button>
      <div className="navbar_innerdiv d-flex justify-content-between flex-column gap-3 pb-4">
        <ul className="nav flex-column gap-2 position-relative">
          <li className="nav-item sidebar-logo">
            <a className="navbar-brand text-white">
              <img src={ImagesUrl.appLogo} alt="Logo" />
            </a>
          </li>
          {children}
        </ul>
        <ul className="nav flex-column  position-relative">
          <li className="nav-item sidebar-link">
            <a className="nav-link" onClick={handleLogout}>
              <span className="nav-icon">
                <img src={ImagesUrl.logout} alt="Logout" />
              </span>
              <span className="nav-text">Logout</span>
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
};
export default Sidebar;
